import { cn } from "@/lib/utils";
import { TRACK_BG } from "./opsColors";

/** Thin split bar under a KPI number: parts of one whole, 2px gaps between parts. */
export function Meter({ segments, title }: { segments: { value: number; className: string }[]; title?: string }) {
  const shown = segments.filter((s) => s.value > 0);
  return (
    <div className={cn("flex gap-[2px] h-1 rounded-full overflow-hidden mt-1", TRACK_BG)} title={title} role="img" aria-label={title}>
      {shown.map((s, i) => (
        <span key={i} className={cn("h-full", s.className)} style={{ flexGrow: s.value, flexBasis: 0 }} />
      ))}
    </div>
  );
}
